export type LastSignInMethod = "phone" | "google";

type MethodStorage = Pick<Storage, "getItem" | "removeItem" | "setItem">;

const LAST_SIGN_IN_METHODS = new Set<LastSignInMethod>(["phone", "google"]);

export function getLastSignInMethodLabel(method: LastSignInMethod) {
	return method === "phone" ? "Phone" : "Google";
}

export function readLastSignInMethod(
	storage: MethodStorage,
	storageKey: string,
) {
	try {
		const storedMethod = storage.getItem(storageKey);

		if (!storedMethod) {
			return null;
		}

		if (LAST_SIGN_IN_METHODS.has(storedMethod as LastSignInMethod)) {
			return storedMethod as LastSignInMethod;
		}

		storage.removeItem(storageKey);
		return null;
	} catch {
		return null;
	}
}

export function saveLastSignInMethod(
	storage: MethodStorage,
	storageKey: string,
	method: LastSignInMethod,
) {
	try {
		storage.setItem(storageKey, method);
	} catch {
		// The badge is only a convenience; auth must not depend on storage.
	}

	return method;
}

export function clearLastSignInMethod(
	storage: MethodStorage,
	storageKey: string,
) {
	try {
		storage.removeItem(storageKey);
	} catch {
		// Nothing to clear if browser storage is unavailable.
	}
}
